import { useWfAlertHistoryStore } from 'src/api/wf/stores/WfAlertHistoryStore';
import WF_HistoryView from './HistoryView';
import useWfAlertHistoryService from 'src/api/wf/service/WfAlertHistoryService';
import { useEffect } from 'react';
import WF_Header from '../../common/header/WfHeader';
import { useNavigate } from 'react-router-dom';

function WF_4_7_2_AlertHistory() {
  const navigate = useNavigate();
  const { fetchHistory } = useWfAlertHistoryService();
  const { history } = useWfAlertHistoryStore();

  useEffect(() => {
    const loadHistory = async () => {
      try {
        await fetchHistory();
      } catch (error) {
        console.error('Failed to fetch history:', error);
      }
    };
    loadHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-gray-100">
      <WF_Header />
      <WF_HistoryView history={history} onClose={() => navigate(-1)} />
    </div>
  );
}

export default WF_4_7_2_AlertHistory;
